// Vorauswahl der Haken in „Daten befüllen" — und die Rückübersetzung der
// ANLAGE-Maske auf die Feldnamen des Anreicherungs-Dienstes.
//
// Die Regel ist an beiden Aufrufstellen dieselbe und deshalb hier zu Hause: der
// Dialog steht in der Firmen-ANLAGE und in der KUNDENAKTE, aber nur die Anlage
// benutzt die Feldnamen des Dienstes unverändert. Die Akte hat eigene Namen und
// bringt ihre Übersetzung selbst mit (redesign/firmendatenAkteFelder.ts).

import { FELD_REIHENFOLGE, type BefundFelder } from "../services/firmendatenService";

/** Was im Ziel schon steht — je Feld des Anreicherungs-Dienstes. */
export type VorhandeneWerte = Partial<Record<keyof BefundFelder, string>>;

/**
 * Welche Haken beim Öffnen der Trefferliste gesetzt sind: ausschließlich Felder,
 * die im Ziel noch LEER sind. Belegte Felder werden angeboten (soweit
 * `darfErsetzen` es zulässt), aber nie vorausgewählt — sonst überschriebe ein
 * unbesehenes „Übernehmen" gepflegte Daten. Reine Leerzeichen zählen als leer.
 */
export function vorausgewaehlteFelder(
  anbietbar: Array<keyof BefundFelder>,
  vorhanden: VorhandeneWerte,
): Set<keyof BefundFelder> {
  return new Set(anbietbar.filter((key) => !String(vorhanden[key] ?? "").trim()));
}

/**
 * Was in der ANLAGE-Maske schon getippt ist. Deren Feldnamen sind identisch mit
 * denen des Anreicherungs-Dienstes — der Firmenname MUSS mit hinein: fehlte er,
 * hielte der Dialog ihn für leer, wählte den Rechtsträger aus dem Impressum vor
 * und ersetzte das Eingetippte ohne Zutun.
 */
export function vorhandeneAnlageWerte(feldWert: (feld: string) => string): VorhandeneWerte {
  const werte: VorhandeneWerte = {};
  for (const key of FELD_REIHENFOLGE) {
    werte[key] = String(feldWert(key) ?? "").trim();
  }
  return werte;
}
